import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-640054dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Seguir aprendiendo", -1))
const _hoisted_5 = { class: "container" }

import { onMounted, ref } from 'vue'
import FollowCourseService from '@/services/FollowCourseService'
import { useAuth } from '@/store/useAuth'
import CourseList from '@/components/cards/CourseList.vue'
import CourseService from '@/services/CourseService'



export default /*#__PURE__*/_defineComponent({
  __name: 'MyCourses',
  setup(__props) {

const store = useAuth()
const followCourseService = new FollowCourseService()
const courseService = new CourseService()
const courses = ref([])
const coursesContent = ref([])
const loading = ref(false)

onMounted(async () => {
    loading.value = true
    if (store.token) {
        courses.value = await followCourseService.getAllCoursesFromUser(store.token)
    }
    courses.value.forEach(async course => {
        const item = await courseService.GetCourse(course.course_id)
        coursesContent.value.push(item)
    });
    Promise.all(coursesContent.value)
    loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_icon, { name: "RiLoader2Fill" }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_icon, { name: "RiLoader2Fill" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (courses.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coursesContent.value, (item) => {
                    return (_openBlock(), _createBlock(CourseList, {
                      key: item.id,
                      content: item
                    }, null, 8, ["content"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}
}

})